import type { AxiosInstance } from 'axios'
import type { ApiRequestConfig } from './types'

export class ApiBase {
  constructor(protected api: AxiosInstance) {}

  delete<R>(url: string, config?: ApiRequestConfig): Promise<R> {
    return this.api.delete(url, config)
  }

  get<R>(url: string, config?: ApiRequestConfig): Promise<R> {
    return this.api.get(url, config)
  }

  patch<R>(url: string, data: unknown, config?: ApiRequestConfig): Promise<R> {
    return this.api.patch(url, data, config)
  }

  post<R>(url: string, data: unknown, config?: ApiRequestConfig): Promise<R> {
    return this.api.post(url, data, config)
  }

  put<R>(url: string, data: unknown, config?: ApiRequestConfig): Promise<R> {
    return this.api.put(url, data, config)
  }
}
